<aside class="layout-sidebar" aria-label="Application modules">


  <div class="layout-sidebar__search">
    <i class="fa fa-search" aria-hidden="true"></i>
    <input type="search" placeholder="Search modules..." [value]="searchTerm"
      (input)="onSearch($any($event.target).value)" aria-label="Search modules" />
  </div>

  <button type="button" class="layout-sidebar__home" [class.is-active]="isActive('/appScaits/mainDashboard')"
    (click)="goHome()" title="Home">
    <span class="layout-sidebar__icon" aria-hidden="true">
      <i class="fa fa-home"></i>
    </span>
    <span class="layout-sidebar__home-label">Home</span>
  </button>

  <p class="layout-sidebar__meta" *ngIf="loading">Loading modules...</p>

  <nav class="layout-sidebar__nav">
    <div class="layout-sidebar__group" *ngFor="let group of filteredGroups">
      <button type="button" class="layout-sidebar__group-btn" [class.is-active]="isGroupActive(group)"
        (click)="onGroupClick(group)" [attr.aria-expanded]="group.expanded" [title]="group.formGroupLabel">
        <span class="layout-sidebar__icon" aria-hidden="true">
          <i class="fa" [ngClass]="iconForGroup(group)"></i>
        </span>
        <span class="layout-sidebar__group-label">{{ group.formGroupLabel }}</span>
        <span class="layout-sidebar__group-count">{{ group.appForms.length }}</span>
        <i class="fa layout-sidebar__chevron" [class.fa-chevron-down]="group.expanded"
          [class.fa-chevron-right]="!group.expanded"></i>
      </button>

      <ul class="layout-sidebar__items" *ngIf="group.expanded">
        <li *ngFor="let item of group.appForms">
          <button type="button" class="layout-sidebar__item" [class.is-active]="isActive(item.route)"
            [disabled]="!item.route" (click)="openForm(item)"
            [title]="item.route ? item.appFormLabel : 'Route not mapped yet'">
            <span class="layout-sidebar__dot" aria-hidden="true"></span>
            <span>{{ item.appFormLabel }}</span>
          </button>
        </li>
      </ul>
    </div>

    <p class="layout-sidebar__empty" *ngIf="!loading && filteredGroups.length === 0">
      No modules available for this user.
    </p>
  </nav>
</aside>

<!--======================== loader ========================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>